/* globals k */

import isNil from 'lodash/isNil';
import { insertOrReplaceUrlParams } from 'zoomforth_zfutils/url_utils.js';

export const LIVE_VERSION = 'live';
export const PUBLISHED_VERSION = LIVE_VERSION;
export const DRAFT_VERSION = 'draft';

// Setting specs on the desktop can force some browsers (Firefox) to override
// the browser settings and always open windows in actual windows rather than
// tabs. By not setting specs we ensure that the new window we open will match
// whatever their browser is doing.
const BROWSER_DEKSTOP_SPECS = '';
const BROWSER_MOBILE_SPECS = 'width=320,height=460,resizable,scrollbars=yes,status=no';

export const getPageVersionViewerURL = (
  urlId, 
  { 
    subpageId=null, 
    shouldForceMobile=false, 
    themeUuid=null,
    siteViewerVersion=null,
    version=PUBLISHED_VERSION
  }={}

)=> {
  let url = `${k.APPLICATION_URL}/page-version-viewer/${urlId}${subpageId ? `#/subpage/${subpageId}` : ''}`;
  url = shouldForceMobile ? insertOrReplaceUrlParams(url, { mobile: 'true' }) : url;
  url = themeUuid ? insertOrReplaceUrlParams(url, { theme_uuid: themeUuid }) : url;
  url = siteViewerVersion ? insertOrReplaceUrlParams(url, { site_viewer_version: siteViewerVersion }) : url;
  url = isNil(version) ? url : insertOrReplaceUrlParams(url, { version });
  return url;
};


export const getPageVersionViewerWindowSpecs = (urlId, { shouldForceMobile=false }={})=> {
  const windowName = `mobile=${shouldForceMobile}:urlId=${urlId}`;
  const specs = shouldForceMobile ? BROWSER_MOBILE_SPECS : BROWSER_DEKSTOP_SPECS;

  return [windowName, specs];
};

// custom speed is not being used for the time being, and will be brought in later
// when the concept of delay/speed is introduced
export function animationClassGenerator(type, speed){

  const animationClassPrefix = "animate__";
  const classPreamble = `${animationClassPrefix}animated`;
  
  const animationClass = `${classPreamble} ${animationClassPrefix}${type}`;
  

  const animationSet =[];
  animationSet.push(animationClass);

  if(speed){
    animationSet.push(`${animationClassPrefix}${speed}`);
  }

  return animationSet.join(' ');
}

export const ConditionalWrapper = ({ children, condition, wrapper }) => {
  return !isNil(condition) && condition ? wrapper(children) : children;
};


export const openPageVersionViewerWindow = (urlId, opts)=>
  openWindow(getPageVersionViewerURL(urlId, opts), ...getPageVersionViewerWindowSpecs(urlId, opts));


export const openWindow = (url, windowName, specs)=> {
  if (window.name == windowName){
    // edge case where a window we've opened as a preview then navigates back to zoomforth
    // and can open its own preview window. in this case, reset the window.name to ''
    window.name = '';
  }

  // bind to the global object to cache existing windows because IE cannot open the same window twice successfully
  var targetWindow = window['open-window-for-page-' + windowName];

  if (targetWindow && !targetWindow.closed) {
    try { // cross domain is not allowed and will raise an error
      targetWindow.location.replace(url);
    } catch (e) {
      targetWindow = window.open(
        url,
        windowName,
        specs
      );
      window['open-window-for-page-' + windowName] = targetWindow;
    }
  } else {
    targetWindow = window.open(
      url,
      windowName,
      specs
    );
    window['open-window-for-page-' + windowName] = targetWindow;
  }

  targetWindow.focus();
};

/* DEPRECATED

  The following functions should be phased out. Their functionality is replaced by the above
  functions which can be used to replicate any of the below's functionality.

*/

export const getLivePageVersionViewerURL = (urlId)=>
  getPageVersionViewerURL(urlId);

export const getDraftPageVersionViewerURL = (urlId, { subpageId, shouldForceMobile, themeUuid, siteViewerVersion }={})=>
  getPageVersionViewerURL(urlId, { subpageId, shouldForceMobile, themeUuid, siteViewerVersion, version: DRAFT_VERSION });
 

export const openMobileWindow = (url, windowName)=> {
  openWindow(url, windowName, BROWSER_MOBILE_SPECS);
};

export const openPreviewWindow = (urlId, { subpageId, themeUuid, siteViewerVersion }={})=> {
  openWindow(getDraftPageVersionViewerURL(urlId, { subpageId, themeUuid, siteViewerVersion }), `_preview-${urlId}`, BROWSER_DEKSTOP_SPECS);
};

export const openVersionWindow = (urlId, version, { subpageId }={})=> {
  openWindow(getPageVersionViewerURL(urlId, { subpageId, version }), `_version-${urlId}`, BROWSER_DEKSTOP_SPECS);
};

export const openVersionMobileWindow = (urlId, version, { subpageId }={})=> {
  openMobileWindow(getPageVersionViewerURL(urlId, { subpageId, version }), `_version-${urlId}`);
};

export const openPreviewMobileWindow = (urlId, { subpageId, themeUuid }={})=> {
  openMobileWindow(getDraftPageVersionViewerURL(urlId, { shouldForceMobile:true, subpageId, themeUuid }), `_preview_mobile-${urlId}`);
};

export const openPublishedWindow = (urlId)=> {
  openWindow(getPageVersionViewerURL(urlId), `_published-${urlId}`);
};

export const openPublishedMobileWindow = (urlId)=> {
  openMobileWindow(getPageVersionViewerURL(urlId, { shouldForceMobile:true }), `_published_mobile${urlId}`);
};
